export default __webpack_public_path__ + "static/media/glass2.30cd60a6.jpg";